const ErrorFallback = ({ error }: { error: unknown }) => (
  <div className="rounded-md bg-red-50 border border-red-200 text-red-700 px-1.5 py-0.5 tracking-tight">
    {String(error)}
  </div>
);

export default ErrorFallback;
